// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__37YKf","title":"AfterImages45_title__2DY1y","images":"AfterImages45_images__2U3cK"};